export * from "./generic-table";
export {
  GenericTableColumnDefinition as GenericTableColumnDefinitionType,
  GenericTableRow as GenericTableRowType
} from "./types";
